import React, { useState, useCallback } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import RichTextEditor from '@/shared/components/RichTextEditor';
import messages from './interactionMessages';

const SummaryEditModal = ({ show, initialSummary, onSave, onClose, intl, loading = false }) => {
  const [summary, setSummary] = useState(initialSummary || '');

  React.useEffect(() => {
    if (!loading && initialSummary !== undefined) {
      setSummary(initialSummary);
    }
  }, [initialSummary, loading]);

  const handleSummaryChange = useCallback(newContent => {
    setSummary(newContent);
  }, []);

  const handleSave = useCallback(() => {
    onSave(summary);
  }, [onSave, summary]);

  return (
    <OkCancelModal
      show={show}
      title={intl.formatMessage(messages.AISummary)}
      onClose={onClose}
      onSave={handleSave}
      disabled={loading}
      okLabel={
        loading ? intl.formatMessage(messages.GeneratingSummary) : intl.formatMessage(messages.Save)
      }
      cancelDisabled={loading}
      size="lg"
    >
      <div>
        <p className="margin10B">
          <FormattedMessage {...messages.AISummaryDescription} />
        </p>

        {loading ? (
          <div className="form-group">
            <div className="text-center margin20T margin20B">
              <i className="fa fa-spin fa-spinner fa-2x margin10B" />
              <div>
                <FormattedMessage {...messages.GeneratingSummary} />
              </div>
              <div className="text-muted margin5T">
                <FormattedMessage {...messages.Loading} />
              </div>
            </div>
            <div
              className="form-control"
              style={{ minHeight: '200px', backgroundColor: '#f9f9f9' }}
            >
              <div className="text-muted text-center" style={{ paddingTop: '80px' }}>
                <FormattedMessage {...messages.SummaryWillAppearHere} />
              </div>
            </div>
          </div>
        ) : (
          <div className="form-group">
            <RichTextEditor
              initialValue={initialSummary}
              onChange={handleSummaryChange}
              base64Images
              id="ai-summary-editor"
            />
          </div>
        )}
      </div>
    </OkCancelModal>
  );
};

export default injectIntl(SummaryEditModal);
